import React from "react";

const SuccessMessage = ({ message }) => {
  if (!message) return null;

  return (
    <div className="bg-green-50 text-green-900 p-3 rounded-md text-sm text-center">
      {message}
    </div>
  );
};

export default SuccessMessage;
